'use client'
import NoImage from '@/components/illustratores/NoImage';
import ImageLoading from '@/components/ImageLoading';
import { currencies } from '@/constants/currencies';
import { WebbedHotel } from '@/types/webbeds';
import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactNode } from "react";

export default function HotelMarker({
  color = "#FF5A1F",
  icon,
  place,
  isActive,
  currency = 'USD',
}: {
  place: WebbedHotel;
  color?: string;
  icon: ReactNode;
  isActive?: boolean,
  currency?: string
}) {

  return (
    <div
      style={{ animationDelay: Math.random() + 's' }}
      id="pin-comp"
      className=" lg:hover:z-20 z-10 group flex items-center justify-center transition-transform duration-300 hover:scale-110" >


      <div className={`${isActive ? 'animate-bounce' : ''}`}>
        {
          place.minPrice && (
            <span
              style={{ borderColor: color, color }}
              className="absolute -right-0.5 -top-1.5 z-30  flex aspect-square h-6 w-6
                       translate-x-1/2 items-center justify-center rounded-full border bg-white px-1 text-center text-sm font-semibold"
            >
              {currencies['USD']}
              {(Number(place.minPrice)).toFixed(0)}
            </span>
          )}
        <svg width="42" height="53" viewBox="0 0 42 53" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M25.0986 41.0903L24.9026 41.1301L24.7881 41.294L21.2425 46.3712L21.2419 46.372C21.214 46.4122 21.1773 46.4445 21.1352 46.4666C21.0932 46.4886 21.0468 46.5 21 46.5C20.9532 46.5 20.9068 46.4886 20.8648 46.4666C20.8227 46.4445 20.786 46.4122 20.7581 46.372L20.7575 46.3712L17.2119 41.294L17.0974 41.1301L16.9014 41.0903C7.54345 39.1917 0.5 30.9178 0.5 21C0.5 9.67816 9.67816 0.5 21 0.5C32.3218 0.5 41.5 9.67816 41.5 21C41.5 30.9178 34.4566 39.1917 25.0986 41.0903Z" fill="#F75751" stroke="white" />
          <path d="M12.75 14C12.75 13.5858 12.4142 13.25 12 13.25C11.5858 13.25 11.25 13.5858 11.25 14V26C11.25 26.4142 11.5858 26.75 12 26.75C12.4142 26.75 12.75 26.4142 12.75 26V24.75H31.142V26.0002C31.142 26.4144 31.4778 26.7502 31.892 26.7502C32.3063 26.7502 32.642 26.4144 32.642 26.0002V24.0001L32.6429 23.643C32.6429 21.648 32.6429 20.6506 32.3623 19.8487C31.8597 18.4125 30.7305 17.2833 29.2943 16.7807C28.4924 16.5001 27.4949 16.5001 25.5 16.5001H25.4977C24.7 16.5001 23.6599 16.5001 23.3394 16.6122C22.7649 16.8133 22.3133 17.2649 22.1122 17.8394C22 18.1602 22 18.5592 22 19.3571V23.25H12.75V14Z" fill="white" />
          <path d="M17 21.5C18.3807 21.5 19.5 20.3807 19.5 19C19.5 17.6193 18.3807 16.5 17 16.5C15.6193 16.5 14.5 17.6193 14.5 19C14.5 20.3807 15.6193 21.5 17 21.5Z" fill="white" />
          <path d="M23 51C23 49.8954 22.1046 49 21 49C19.8954 49 19 49.8954 19 51C19 52.1046 19.8954 53 21 53C22.1046 53 23 52.1046 23 51Z" fill="#F75751" />
        </svg>

      </div>
    </div>
  );
};